









































import AppTextModule from "../store/modules/appTextModule";
import { Component } from "vue-property-decorator";
import ViewBase from "../views/ViewBase";
import { getModule } from "vuex-module-decorators";

const appTextStore = getModule(AppTextModule);

@Component({
  components: {}
})
export default class Main extends ViewBase {
  protected get title() {
    return "Main";
  }

  private get introduction() {
    return this.getText("text.introduction");
  }

  private get chronologyTitle() {
    return this.getText("text.chronology");
  }

  private get placesTitle() {
    return this.getText("text.places");
  }

  private get mapTitle() {
    return this.getText("text.map");
  }

  private getText(key: string) {
    return appTextStore.appTextByKey(key);
  }
}
